import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconNotes",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function h(e, t, i, u, _, a) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--notes"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Notes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 1.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1h.5A1.5 1.5 0 0 1 11 3v7a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 2 10V3a1.5 1.5 0 0 1 1.5-1.5H4Zm0 1h-.5A.5.5 0 0 0 3 3v7a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Zm4 0H5v-1h3v1Zm-4 3a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5Zm2 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5ZM4 8a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4.5A.5.5 0 0 1 4 8Zm2 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 6 8Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const H = /* @__PURE__ */ s(c, [["render", h]]);
export {
  H as default
};
//# sourceMappingURL=notes.js.map
